import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { BannerComponent } from '../banner/banner.component';
import { BannerTickerItem, CategoryCard, Product } from '../../core/models/interfaces-general';
import { ProductCarouselSectionComponent } from '../../shared/components/product-carousel-section.component';
import { CategoryCarouselSectionComponent } from '../../shared/components/category-carousel-section.component';
import { AboutFeaturesBannerComponent } from '../components/about-features-banner.component';
import { ProductoService } from '../../core/services/producto.service';
import { CategoriaService } from '../../core/services/categoria.service';
import { ProductoMapper } from '../../core/mappers/producto.mapper';
import { CategoriaMapper } from '../../core/mappers/categoria.mapper';
import { Constante } from '../../constante';
import { UiLoadingComponent } from '../../shared/components/ui-loading.component';

@Component({
    selector: 'app-home',
    imports: [
        CommonModule,
        BannerComponent,
        ProductCarouselSectionComponent,
        CategoryCarouselSectionComponent,
        AboutFeaturesBannerComponent,
        UiLoadingComponent
    ],
    templateUrl: './home.html',
    styles: ''
})
export class HomeComponent implements OnInit {
    private productoService = inject(ProductoService);
    private categoriaService = inject(CategoriaService);
    private router = inject(Router);

    imagenPrueba = 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?q=80&w=1000';
    listaCinta: BannerTickerItem[] = [
        { text: 'FLORES Y REGALOS PARA HOY', url: Constante.URL_CATALOGO },
        { text: 'ENVÍO GRATIS EN SECTORES SELECCIONADOS', url: Constante.URL_CATALOGO },
        { text: 'NUEVA COLECCIÓN DE GIRASOLES', url: Constante.URL_CATALOGO },
        { text: 'DETALLES EXCLUSIVOS Y PERSONALIZADOS', url: Constante.URL_CATALOGO }
    ];

    listaProductos = signal<Product[]>([]);
    misCategorias = signal<CategoryCard[]>([]);
    loading = signal(true);
    viewAllUrl = Constante.URL_CATALOGO;

    ngOnInit(): void {
        let pending = 2;
        const done = () => {
            pending -= 1;
            if (pending <= 0) this.loading.set(false);
        };

        this.productoService.listProductos({ pageNumber: 1, pageSize: 8 }).subscribe({
            next: (page) => {
                this.listaProductos.set((page.data ?? []).map((item) => ProductoMapper.toCarousel(item)));
                done();
            },
            error: () => done()
        });

        this.categoriaService.listCategorias().subscribe({
            next: (categorias) => {
                this.misCategorias.set(
                    CategoriaMapper.flatten(categorias)
                        .slice(0, 8)
                        .map((item) => CategoriaMapper.toCard(item))
                );
                done();
            },
            error: () => done()
        });
    }

    handleBannerButtonClick() {
        this.router.navigate([Constante.URL_CATALOGO]);
    }
}
